import { CareerEnum, CareerPath, Job, JobEnum } from '../types'

export const CAREERS: { [key in CareerEnum]: CareerPath } = {
  local_labor: {
    key: 'local_labor',
    name: 'Local Labor',
    description: 'Entry-level jobs available in all locations.',
    unlockRules: [],
    jobs: [
      'dishwasher',
      'food_delivery',
      'street_vendor_helper',
      'surfboard_rental_assistant',
      'beach_lifeguard_assistant',
      'barista_waiter_beach_cafe',
      'tour_guide_helper',
      'surf_school_assistant',
      'tour_guide',
      'beach_manager'
    ]
  },
  south_africa_career: {
    key: 'south_africa_career',
    name: 'South Africa',
    description: 'South Africa Career Path: Teaching and Extreme Tours',
    unlockRules: [
      { category: 'location', key: 'current', value: 'south_africa' },
      { category: 'level', key: 'skill', value: 3 }
    ],
    jobs: ['teaching_italian', 'shark_cage_dive_guide', 'safari_surf_tour_operator']
  },
  australia_east_career: {
    key: 'australia_east_career',
    name: 'Australia East',
    description: 'Australia East Career Path: Surf Shaping & Tourism',
    unlockRules: [
      { category: 'location', key: 'current', value: 'australia_east_coast' },
      { category: 'job', key: 'surfboard_rental_assistant', value: 1 }
    ],
    jobs: ['surfboard_shaping_apprentice', 'surfboard_shaper', 'pro_surfboard_designer']
  },
  portugal_career: {
    key: 'portugal_career',
    name: 'Portugal',
    description: 'Portugal Career Path: Surf Tourism and Guiding',
    unlockRules: [
      { category: 'location', key: 'current', value: 'portugal' },
      { category: 'job', key: 'tour_guide_helper', value: 1 },
      { category: 'level', key: 'fitness', value: 3 }
    ],
    jobs: ['surf_tour_guide', 'advanced_surf_coach', 'big_wave_surf_guide']
  },
  california_career: {
    key: 'california_career',
    name: 'California',
    description: 'California Career Path: Lifeguarding and Surfing Services',
    unlockRules: [
      { category: 'location', key: 'current', value: 'california' },
      { category: 'job', key: 'tour_guide', value: 1 }
    ],
    jobs: ['beach_lifeguard', 'surf_camp_coordinator', 'pro_surf_instructor']
  },
  indonesia_career: {
    key: 'indonesia_career',
    name: 'Indonesia',
    description: 'Indonesia Career Path: Surf & Diving',
    unlockRules: [
      { category: 'location', key: 'current', value: 'indonesia' },
      { category: 'level', key: 'fitness', value: 4 },
      { category: 'job', key: 'tour_guide', value: 1 }
    ],
    jobs: ['diving_instructor', 'surf_and_yoga_retreat_manager', 'private_surf_guide_high_end_tourists']
  },
  surf_camps_and_coaching: {
    key: 'surf_camps_and_coaching',
    name: 'Surf Camps',
    description: 'Jobs related to surf camps and coaching.',
    unlockRules: [{ category: 'level', key: 'skill', value: 3 }],
    jobs: [
      'hostel_cleaner',
      'receptionist_surf_hostel',
      'surf_camp_organizer',
      'surf_guide',
      'junior_surf_coach',
      'senior_surf_coach',
      'surf_camp_manager'
    ]
  },
  video_blogging: {
    key: 'video_blogging',
    name: 'Vlogging',
    description: 'Career path for creating surf-related video content.',
    unlockRules: [{ category: 'level', key: 'skill', value: 7 }],
    jobs: ['beginner_surf_vlogger', 'surf_spot_reviewer', 'gear_reviewer', 'surf_travel_vlogger', 'pro_level_vlogger']
  },
  sponsorships: {
    key: 'sponsorships',
    name: 'Sponsorships',
    description: 'Income from surf-related sponsorships.',
    unlockRules: [{ category: 'level', key: 'skill', value: 8 }],
    jobs: [
      'local_surfboard_sponsor',
      'wetsuit_sponsor',
      'major_surf_brand',
      'exclusive_gear_sponsor',
      'global_brand_ambassador'
    ]
  },
  entrepreneur_path: {
    key: 'entrepreneur_path',
    name: 'Entrepreneur',
    description: 'Start and manage your own surf-related businesses.',
    unlockRules: [
      { category: 'currency', key: 'money', value: 10000 },
      { category: 'level', key: 'skill', value: 5 }
    ],
    jobs: [
      'surfboard_shaping_brand',
      'surf_clothing_brand',
      'online_surf_coaching_platform',
      'surf_camp_franchise',
      'wave_pool_business'
    ]
  }
}

export const JOBS: { [key in JobEnum]: Job } = {
  dishwasher: {
    key: 'dishwasher',
    name: 'Dishwasher',
    description: 'Basic entry-level job available in any location.',
    income: 7,
    unlockRules: []
  },
  food_delivery: {
    key: 'food_delivery',
    name: 'Food Delivery',
    description: 'Slightly higher pay with small energy cost. Requires a bike (small investment).',
    income: 12,
    unlockRules: [
      { category: 'job', key: 'dishwasher', value: 10 },
      { category: 'purchase', key: 'bike', value: 1 }
    ]
  },
  street_vendor_helper: {
    key: 'street_vendor_helper',
    name: 'Street Vendor Helper',
    description: 'Assist local vendors selling goods. Available in tourist-heavy spots.',
    income: 15,
    unlockRules: [{ category: 'job', key: 'food_delivery', value: 20 }]
  },
  surfboard_rental_assistant: {
    key: 'surfboard_rental_assistant',
    name: 'Surfboard Rental Assistant',
    description: 'Work at surfboard rental shacks. Offers perks like free boards (energy-saving).',
    income: 20,
    unlockRules: [
      { category: 'job', key: 'street_vendor_helper', value: 35 },
      { category: 'level', key: 'skill', value: 2 }
    ]
  },
  beach_lifeguard_assistant: {
    key: 'beach_lifeguard_assistant',
    name: 'Beach Lifeguard Assistant',
    description: 'Help lifeguards and manage beach safety.',
    income: 25,
    respectIncome: 0.1,
    unlockRules: [
      { category: 'job', key: 'surfboard_rental_assistant', value: 40 },
      { category: 'level', key: 'fitness', value: 2 },
      { category: 'purchase', key: 'first_aid_training', value: 1 }
    ]
  },
  barista_waiter_beach_cafe: {
    key: 'barista_waiter_beach_cafe',
    name: 'Barista/Waiter at Beach Cafe',
    description: 'Work at a popular beach cafe. Tips add to the base income.',
    income: 34,
    unlockRules: [{ category: 'job', key: 'beach_lifeguard_assistant', value: 65 }]
  },
  tour_guide_helper: {
    key: 'tour_guide_helper',
    name: 'Tour Guide Helper',
    description: 'Help tourists navigate the surf scene or local landmarks.',
    income: 50,
    unlockRules: [
      { category: 'job', key: 'barista_waiter_beach_cafe', value: 95 },
      { category: 'level', key: 'wave_reading', value: 2 }
    ]
  },
  surf_school_assistant: {
    key: 'surf_school_assistant',
    name: 'Surf School Assistant',
    description: 'Help with surf lessons by handling logistics and beginners.',
    income: 69,
    unlockRules: [
      { category: 'job', key: 'tour_guide_helper', value: 130 },
      { category: 'level', key: 'skill', value: 2 }
    ]
  },
  tour_guide: {
    key: 'tour_guide',
    name: 'Tour Guide',
    description: 'Lead tourists on full surf tours and beach adventures.',
    income: 88,
    unlockRules: [
      { category: 'job', key: 'surf_school_assistant', value: 180 },
      { category: 'level', key: 'wave_reading', value: 3 }
    ]
  },
  beach_manager: {
    key: 'beach_manager',
    name: 'Beach Manager',
    description: 'Manage rentals, beach cafes, and tourist activities.',
    income: 125,
    unlockRules: [{ category: 'job', key: 'tour_guide', value: 250 }]
  },
  teaching_italian: {
    key: 'teaching_italian',
    name: 'Teaching Italian',
    description: 'Teach Italian, offering language lessons on the side of surfing.',
    income: 45,
    unlockRules: []
  },
  shark_cage_dive_guide: {
    key: 'shark_cage_dive_guide',
    name: 'Shark Cage Dive Guide',
    description: 'Take tourists on shark cage dives. High risk, high reward.',
    income: 80,
    unlockRules: [
      { category: 'job', key: 'teaching_italian', value: 40 },
      { category: 'level', key: 'fitness', value: 4 }
    ]
  },
  safari_surf_tour_operator: {
    key: 'safari_surf_tour_operator',
    name: 'Safari Surf Tour Operator',
    description: 'Combine surf guiding with unique safaris to attract high-end tourists.',
    income: 150,
    unlockRules: [{ category: 'job', key: 'shark_cage_dive_guide', value: 80 }]
  },
  surfboard_shaping_apprentice: {
    key: 'surfboard_shaping_apprentice',
    name: 'Surfboard Shaping Apprentice',
    description: 'Learn how to shape surfboards from a pro.',
    income: 80,
    respectIncome: 0.1,
    unlockRules: [{ category: 'job', key: 'surfboard_rental_assistant', value: 20 }]
  },
  surfboard_shaper: {
    key: 'surfboard_shaper',
    name: 'Surfboard Shaper',
    description: 'Build custom boards for local surfers.',
    income: 160,
    respectIncome: 0.15,
    unlockRules: [{ category: 'job', key: 'surfboard_shaping_apprentice', value: 110 }]
  },
  pro_surfboard_designer: {
    key: 'pro_surfboard_designer',
    name: 'Pro Surfboard Designer',
    description: 'Create signature boards for pro surfers.',
    income: 240,
    respectIncome: 0.4,
    unlockRules: [{ category: 'job', key: 'surfboard_shaper', value: 220 }]
  },
  surf_tour_guide: {
    key: 'surf_tour_guide',
    name: 'Surf Tour Guide',
    description: "Lead tourists through Portugal's famous surf spots, teaching them about waves and surf culture.",
    income: 40,
    respectIncome: 0.1,
    unlockRules: []
  },
  advanced_surf_coach: {
    key: 'advanced_surf_coach',
    name: 'Advanced Surf Coach',
    description: "Train tourists and semi-pro surfers at Portugal's top surf camps.",
    income: 60,
    respectIncome: 0.2,
    unlockRules: [
      { category: 'job', key: 'surf_tour_guide', value: 80 },
      { category: 'level', key: 'skill', value: 5 }
    ]
  },
  big_wave_surf_guide: {
    key: 'big_wave_surf_guide',
    name: 'Big Wave Surf Guide',
    description: "Guide elite surfers to tackle Nazaré's legendary big waves.",
    income: 140,
    respectIncome: 0.4,
    unlockRules: [
      { category: 'job', key: 'advanced_surf_coach', value: 160 },
      { category: 'level', key: 'skill', value: 7 },
      { category: 'level', key: 'fitness', value: 5 }
    ]
  },
  beach_lifeguard: {
    key: 'beach_lifeguard',
    name: 'Beach Lifeguard',
    description: 'Full lifeguard duties, saving lives and protecting the beach.',
    income: 60,
    unlockRules: [{ category: 'level', key: 'fitness', value: 3 }]
  },
  surf_camp_coordinator: {
    key: 'surf_camp_coordinator',
    name: 'Surf Camp Coordinator',
    description: 'Organize surf camps, events, and teach advanced surfers.',
    income: 120,
    respectIncome: 0.1,
    unlockRules: [
      { category: 'job', key: 'beach_lifeguard', value: 95 },
      { category: 'level', key: 'skill', value: 4 }
    ]
  },
  pro_surf_instructor: {
    key: 'pro_surf_instructor',
    name: 'Pro Surf Instructor',
    description: 'Teach celebrities and aspiring pros.',
    income: 190,
    respectIncome: 0.2,
    unlockRules: [
      { category: 'job', key: 'surf_camp_coordinator', value: 190 },
      { category: 'level', key: 'skill', value: 6 }
    ]
  },
  diving_instructor: {
    key: 'diving_instructor',
    name: 'Diving Instructor',
    description: "Teach tourists how to dive and explore Indonesia's reefs.",
    income: 100,
    unlockRules: [{ category: 'level', key: 'fitness', value: 4 }]
  },
  surf_and_yoga_retreat_manager: {
    key: 'surf_and_yoga_retreat_manager',
    name: 'Surf and Yoga Retreat Manager',
    description: 'Run luxurious surf and yoga retreats.',
    income: 200,
    unlockRules: [
      { category: 'job', key: 'diving_instructor', value: 130 },
      { category: 'level', key: 'skill', value: 5 }
    ]
  },
  private_surf_guide_high_end_tourists: {
    key: 'private_surf_guide_high_end_tourists',
    name: 'Private Surf Guide for High-End Tourists',
    description: 'Offer personalized surf tours to wealthy tourists and influencers.',
    income: 300,
    unlockRules: [
      { category: 'job', key: 'surf_and_yoga_retreat_manager', value: 260 },
      { category: 'level', key: 'skill', value: 7 }
    ]
  },
  hostel_cleaner: {
    key: 'hostel_cleaner',
    name: 'Hostel Cleaner',
    description: 'Basic job cleaning surf hostels. Starting point for surf camp work.',
    income: 25,
    unlockRules: []
  },
  receptionist_surf_hostel: {
    key: 'receptionist_surf_hostel',
    name: 'Receptionist at Surf Hostel',
    description: 'Greet guests, handle bookings, and manage day-to-day hostel operations.',
    income: 35,
    unlockRules: [{ category: 'job', key: 'hostel_cleaner', value: 20 }]
  },
  surf_camp_organizer: {
    key: 'surf_camp_organizer',
    name: 'Surf Camp Organizer',
    description: 'Organize surf lessons, trips, and events for camp guests.',
    income: 40,
    unlockRules: [{ category: 'job', key: 'receptionist_surf_hostel', value: 40 }]
  },
  surf_guide: {
    key: 'surf_guide',
    name: 'Surf Guide',
    description: 'Take groups to the best surf spots and offer basic instruction.',
    income: 50,
    respectIncome: 0.1,
    unlockRules: [{ category: 'job', key: 'surf_camp_organizer', value: 60 }]
  },
  junior_surf_coach: {
    key: 'junior_surf_coach',
    name: 'Junior Surf Coach',
    description: 'Teach beginners the basics of surfing.',
    income: 60,
    respectIncome: 0.1,
    unlockRules: [
      { category: 'job', key: 'surf_guide', value: 80 },
      { category: 'level', key: 'skill', value: 5 }
    ]
  },
  senior_surf_coach: {
    key: 'senior_surf_coach',
    name: 'Senior Surf Coach',
    description: 'Teach more advanced surfers, refine their techniques, and help them with competition-level training.',
    income: 80,
    respectIncome: 0.2,
    unlockRules: [{ category: 'job', key: 'junior_surf_coach', value: 100 }]
  },
  surf_camp_manager: {
    key: 'surf_camp_manager',
    name: 'Surf Camp Manager',
    description: 'Manage all operations, from logistics to coaching staff.',
    income: 100,
    unlockRules: [{ category: 'job', key: 'senior_surf_coach', value: 120 }]
  },
  beginner_surf_vlogger: {
    key: 'beginner_surf_vlogger',
    name: 'Beginner Surf Vlogger',
    description: 'Start your social media presence. Minimal income initially.',
    income: 13,
    unlockRules: []
  },
  surf_spot_reviewer: {
    key: 'surf_spot_reviewer',
    name: 'Surf Spot Reviewer',
    description: 'Review local surf spots for a small but growing audience.',
    income: 25,
    unlockRules: [{ category: 'job', key: 'beginner_surf_vlogger', value: 400 }]
  },
  gear_reviewer: {
    key: 'gear_reviewer',
    name: 'Gear Reviewer',
    description: 'Review surfboards, wetsuits, and gear. Occasionally receive free products.',
    income: 63,
    unlockRules: [{ category: 'job', key: 'surf_spot_reviewer', value: 800 }]
  },
  surf_travel_vlogger: {
    key: 'surf_travel_vlogger',
    name: 'Surf Travel Vlogger',
    description: 'Post travel vlogs and gain sponsorship deals from surf tourism companies.',
    income: 125,
    unlockRules: [{ category: 'job', key: 'gear_reviewer', value: 1200 }]
  },
  pro_level_vlogger: {
    key: 'pro_level_vlogger',
    name: 'Pro-Level Vlogger',
    description:
      "You've become an online surf influencer. Major surf brands sponsor your content and you generate ad revenue from a large following.",
    income: 625,
    unlockRules: [{ category: 'job', key: 'surf_travel_vlogger', value: 1600 }]
  },
  local_surfboard_sponsor: {
    key: 'local_surfboard_sponsor',
    name: 'Local Surfboard Sponsor',
    description: 'Sponsored by a small local surfboard company.',
    income: 13,
    unlockRules: []
  },
  wetsuit_sponsor: {
    key: 'wetsuit_sponsor',
    name: 'Wetsuit Sponsor',
    description: "You're sponsored by a mid-tier wetsuit brand.",
    income: 63,
    unlockRules: [{ category: 'job', key: 'local_surfboard_sponsor', value: 40 }]
  },
  major_surf_brand: {
    key: 'major_surf_brand',
    name: 'Major Surf Brand',
    description: 'A significant brand sponsors your travels and competitions.',
    income: 125,
    unlockRules: [{ category: 'job', key: 'wetsuit_sponsor', value: 80 }]
  },
  exclusive_gear_sponsor: {
    key: 'exclusive_gear_sponsor',
    name: 'Exclusive Gear Sponsor',
    description: 'A high-end surf gear company sponsors you exclusively.',
    income: 260,
    unlockRules: [{ category: 'job', key: 'major_surf_brand', value: 120 }]
  },
  global_brand_ambassador: {
    key: 'global_brand_ambassador',
    name: 'Global Brand Ambassador',
    description:
      "You're now a global ambassador for a top surf brand, representing them at events, creating content, and promoting their products worldwide.",
    income: 400,
    unlockRules: [{ category: 'job', key: 'exclusive_gear_sponsor', value: 160 }]
  },
  surfboard_shaping_brand: {
    key: 'surfboard_shaping_brand',
    name: 'Surfboard Shaping Brand',
    description: 'Launch your own line of custom surfboards.',
    income: 1275,
    unlockRules: [
      { category: 'job', key: 'pro_surfboard_designer', value: 1 },
      { category: 'purchase', key: 'surfboard_shaping_brand', value: 1 }
    ]
  },
  surf_clothing_brand: {
    key: 'surf_clothing_brand',
    name: 'Surf Clothing Brand',
    description: 'Start a clothing line and sell beachwear or surf fashion.',
    income: 3200,
    unlockRules: [{ category: 'purchase', key: 'surf_clothing_brand', value: 1 }]
  },
  online_surf_coaching_platform: {
    key: 'online_surf_coaching_platform',
    name: 'Online Surf Coaching Platform',
    description: 'Offer online surf lessons, reaching a global audience through digital coaching.',
    income: 5900,
    unlockRules: [
      { category: 'purchase', key: 'online_surf_coaching', value: 1 },
      { category: 'job', key: 'senior_surf_coach', value: 1 }
    ]
  },
  surf_camp_franchise: {
    key: 'surf_camp_franchise',
    name: 'Surf Camp Franchise',
    description: 'Open a chain of surf camps across popular surf destinations.',
    income: 12200,
    unlockRules: [
      { category: 'purchase', key: 'surf_camp_franchise', value: 1 },
      { category: 'job', key: 'surf_camp_manager', value: 1 }
    ]
  },
  wave_pool_business: {
    key: 'wave_pool_business',
    name: 'Wave Pool Business',
    description: 'Build and manage a wave pool park, providing passive income through tourist visits.',
    income: 21800,
    unlockRules: [{ category: 'purchase', key: 'wave_pool_tech', value: 1 }]
  }
}

export default { CAREERS, JOBS }
